import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmCardFooter],hlm-card-footer',
  host: { 'data-slot': 'card-footer' },
})
export class HlmCardFooter {
  constructor() {
    classes(
      () => 'rounded-b-lg px-(--card-spacing) [.border-t]:pt-(--card-spacing) flex items-center'
    );
  }
}
